import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import { compose } from "redux";
import { Redirect } from 'react-router-dom';

import TopBar from "../../components/TopBar";
import Sidebar from "../../components/Sidebar";

import { getProfile, updateProfile, resetProfileUpdated, resetErrorMessage, addProfileImage, changePassword, sendPasswordReset } from "../../store/actions/profileActions";
import { getSettings } from "../../store/actions/settingsAction";
import { logOut } from "../../store/actions/authActions";

function Profile(props) {
    const { t, i18n } = useTranslation();
    const LANG_STORAGE_KEY = "rabo_i18n_language";
    const activeLang = i18n.resolvedLanguage || i18n.language || "en";
    const setAppLanguage = (lng) => {
        i18n.changeLanguage(lng);
        localStorage.setItem(LANG_STORAGE_KEY, lng);
    };

    const { token, profile, profile_updated, error_message, settings, getProfileFN, updateProfileFN, resetProfileUpdatedFN, resetErrorMessageFN, addProfileImageFN, changePasswordFN, sendPasswordResetFN, getSettingsFN, logOutFN } = props;

    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);
    const [activeTab, setActiveTab] = useState("Profile");

    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [email, setEmail] = useState("");
    const [profileImage, setProfileImage] = useState(null);
    const [phoneNumber, setPhoneNumber] = useState("");
    const [bio, setBio] = useState("");
    const [location, setLocation] = useState("");
    const [website, setWebsite] = useState("");

   
    const [currentPassword, setCurrentPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmNewPassword, setConfirmNewPassword] = useState("");
    const [showCurrentPassword, setShowCurrentPassword] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [passwordError, setPasswordError] = useState(null);
    const [passwordSuccess, setPasswordSuccess] = useState(null);
    const [resetSuccess, setResetSuccess] = useState(null);
    const [isResetting, setIsResetting] = useState(false);
    const [enable2FA, setEnable2FA] = useState(false);
    const [loginAlerts, setLoginAlerts] = useState(true);

    const [emailProductUpdates, setEmailProductUpdates] = useState(true);
    const [emailSecurityAlerts, setEmailSecurityAlerts] = useState(true);
    const [emailNewsletter, setEmailNewsletter] = useState(true);
    const [emailComments, setEmailComments] = useState(true);
    const [emailMentions, setEmailMentions] = useState(true);
    const [emailNewFollowers, setEmailNewFollowers] = useState(true);
    const [emailDirectMessages, setEmailDirectMessages] = useState(true);
    const [emailTipsTutorials, setEmailTipsTutorials] = useState(false);

    const [pushMessages, setPushMessages] = useState(true);
    const [pushComments, setPushComments] = useState(true);
    const [pushMentions, setPushMentions] = useState(true);
    const [pushNewFollowers, setPushNewFollowers] = useState(false);

    const [smsSecurityAlerts, setSmsSecurityAlerts] = useState(true);
    const [smsLoginAttempts, setSmsLoginAttempts] = useState(false);

    const [profileVisibility, setProfileVisibility] = useState("public");
    const [showActivityStatus, setShowActivityStatus] = useState(true);
    const [readReceipts, setReadReceipts] = useState(true);
    const [searchableProfile, setSearchableProfile] = useState(true);
    const [showEmailAddress, setShowEmailAddress] = useState(false);
    const [showPhoneNumber, setShowPhoneNumber] = useState(false);
    const [analytics, setAnalytics] = useState(true);
    const [marketingCommunications, setMarketingCommunications] = useState(false);
    const [thirdPartySharing, setThirdPartySharing] = useState(false);

    const [language, setLanguage] = useState("English");
    const [theme, setTheme] = useState("Light");
    const [timezone, setTimezone] = useState("");
    const [googleConnected, setGoogleConnected] = useState(true);
    const [githubConnected, setGithubConnected] = useState(false);

    const resetPrivacyDefaults = () => {
        setProfileVisibility("public");
        setShowActivityStatus(true);
        setReadReceipts(true);
        setSearchableProfile(true);
        setShowEmailAddress(false);
        setShowPhoneNumber(false);
        setAnalytics(true);
        setMarketingCommunications(false);
        setThirdPartySharing(false);
    };

    const handleSavePrivacyChanges = () => {
        setSuccess(t("accountSettings.messages.privacySaved"));
        setTimeout(() => {
            setSuccess(null);
        }, 3000);
    };

    const resetNotificationDefaults = () => {
        setEmailProductUpdates(true);
        setEmailSecurityAlerts(true);
        setEmailNewsletter(true);
        setEmailComments(true);
        setEmailMentions(true);
        setEmailNewFollowers(true);
        setEmailDirectMessages(true);
        setEmailTipsTutorials(false);
        setPushMessages(true);
        setPushComments(true);
        setPushMentions(true);
        setPushNewFollowers(false);
        setSmsSecurityAlerts(true);
        setSmsLoginAttempts(false);
    };

    const handleSavePreferences = () => {
        setSuccess(t("accountSettings.messages.preferencesSaved"));
        setTimeout(() => {
            setSuccess(null);
        }, 3000);
    };

    const handleImageChange = (e) => {
        if (e.target.files && e.target.files[0]) {
            const file = e.target.files[0];
            const fileType = file.type;

            if (fileType.startsWith('image/')) {
                const fileSize = file.size / 1024 / 1024;
                if (fileSize > 2) {
                    setError(t("accountSettings.messages.fileSizeError"));
                    return;
                }
                setProfileImage(URL.createObjectURL(file));
                addProfileImageFN(file);
            } else {
                setError(t("accountSettings.messages.invalidImage"));
            }
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setError(null);
        updateProfileFN({ 
            first_name: firstName, 
            last_name: lastName, 
            email: email,
            avatar: profileImage 
        });
    };

    const handleCancel = () => {
        if (profile) {
            setFirstName(profile.first_name || "");
            setLastName(profile.last_name || "");
            setEmail(profile.email || "");
            setProfileImage(profile.avatar || null);
        }
        setPhoneNumber("");
        setBio("");
        setLocation("");
        setWebsite("");
        setError(null);
        setSuccess(null);
    };

    useEffect(() => {
        getProfileFN();
        getSettingsFN();
    }, []);

    useEffect(() => {
        if (settings && settings.timezone) {
            setTimezone(settings.timezone);
        }
    }, [settings]);

    useEffect(() => {
        if (profile) {
            setFirstName(profile.first_name || "");
            setLastName(profile.last_name || "");
            setEmail(profile.email || "");
            if (profile.avatar) {
                setProfileImage(profile.avatar);
            }
        }
    }, [profile]);

    useEffect(() => {
        if (profile_updated && activeTab !== "Password") {
            setSuccess(t("accountSettings.messages.profileUpdated"));
            resetProfileUpdatedFN();
            setTimeout(() => {
                setSuccess(null);
            }, 3000);
        }
    }, [profile_updated, resetProfileUpdatedFN, activeTab, t]);

    useEffect(() => {
        if (error_message) {
            setError(error_message);
            resetErrorMessageFN();
        }
    }, [error_message, resetErrorMessageFN]);

    const getUsername = () => {
        if (email) {
            return email.split('@')[0];
        }
        return "";
    };

    const formatDate = (dateString) => {
        if (!dateString) return "N/A";
        const date = new Date(dateString);
        const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        return `${months[date.getMonth()]} ${date.getDate()}, ${date.getFullYear()}`;
    };

    const handleLogOut = () => {
        logOutFN();
    };

    const handlePasswordChange = (e) => {
        e.preventDefault();
        setPasswordError(null);
        setPasswordSuccess(null);

        // Client-side validation
        if (!currentPassword || !newPassword || !confirmNewPassword) {
            setPasswordError(t("accountSettings.passwordErrors.allFields"));
            return;
        }

        if (newPassword !== confirmNewPassword) {
            setPasswordError(t("accountSettings.passwordErrors.mismatch"));
            return;
        }

        // Password strength validation
        const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
        if (!passwordRegex.test(newPassword)) {
            setPasswordError(t("accountSettings.passwordErrors.strength"));
            return;
        }

        changePasswordFN({
            currentPassword,
            newPassword,
            confirmNewPassword
        });
    };

    const handlePasswordCancel = () => {
        setCurrentPassword("");
        setNewPassword("");
        setConfirmNewPassword("");
        setPasswordError(null);
        setPasswordSuccess(null);
    };

    const handlePasswordReset = () => {
        if (!email) {
            setPasswordError(t("accountSettings.passwordErrors.emailRequired"));
            return;
        }
        setPasswordError(null);
        setResetSuccess(null);
        setIsResetting(true);
        sendPasswordResetFN(email);
    };

    useEffect(() => {
        if (profile_updated && activeTab === "Password") {
            if (isResetting) {
                setResetSuccess(t("accountSettings.messages.resetSent"));
                setIsResetting(false);
            } else {
                setPasswordSuccess(t("accountSettings.messages.passwordUpdated"));
                setCurrentPassword("");
                setNewPassword("");
                setConfirmNewPassword("");
            }
            resetProfileUpdatedFN();
            setTimeout(() => {
                setPasswordSuccess(null);
                setResetSuccess(null);
            }, 3000);
        }
    }, [profile_updated, activeTab, resetProfileUpdatedFN, isResetting, t]);

    useEffect(() => {
        if (error_message && activeTab === "Password") {
            setPasswordError(error_message);
            setIsResetting(false);
            resetErrorMessageFN();
        }
    }, [error_message, activeTab, resetErrorMessageFN]);

    return token ? (
        <div className="flex flex-col w-full h-screen overflow-hidden bg-gray-50">
            <TopBar className="fixed top-0 left-0 right-0 z-10" />
            <div className="flex flex-row w-full flex-1 min-h-0">
                <Sidebar className="fixed top-0 left-0 h-screen pt-[64px] z-0" />
                <div id="dashboard-content" className="flex flex-col w-full overflow-y-auto pt-4 flex-1 min-h-0">
                    <div className="max-w-4xl mx-auto w-full px-8 pb-8 pt-0 min-h-full">
                        <div className="mb-8">
                            <h1 className="text-3xl font-semibold text-gray-900 mb-2">{t("accountSettings.title")}</h1>
                            <p className="text-gray-600">{t("accountSettings.subtitle")}</p>
                        </div>

                        <div className="mb-8">
                            <nav className="flex justify-between bg-gray-200 rounded-xl p-1 w-full" aria-label={t("accountSettings.title")}>
                                <button
                                    onClick={() => setActiveTab("Profile")}
                                    className={`flex items-center space-x-2 px-4 py-2 rounded-md font-medium text-sm transition-colors ${
                                        activeTab === "Profile"
                                            ? "bg-white text-gray-900 shadow-sm"
                                            : "text-gray-600 hover:text-gray-900"
                                    }`}
                                >
                                    <i className="fa fa-user"></i>
                                    <span>{t("accountSettings.tabs.profile")}</span>
                                </button>
                                <button
                                    onClick={() => setActiveTab("Password")}
                                    className={`flex items-center space-x-2 px-4 py-2 rounded-md font-medium text-sm transition-colors ${
                                        activeTab === "Password"
                                            ? "bg-white text-gray-900 shadow-sm"
                                            : "text-gray-600 hover:text-gray-900"
                                    }`}
                                >
                                    <i className="fa fa-lock"></i>
                                    <span>{t("accountSettings.tabs.password")}</span>
                                </button>
                                <button
                                    onClick={() => setActiveTab("Security")}
                                    className={`flex items-center space-x-2 px-4 py-2 rounded-md font-medium text-sm transition-colors ${
                                        activeTab === "Security"
                                            ? "bg-white text-gray-900 shadow-sm"
                                            : "text-gray-600 hover:text-gray-900"
                                    }`}
                                >
                                    <i className="fa fa-shield-alt"></i>
                                    <span>{t("accountSettings.tabs.security")}</span>
                                </button>
                                <button
                                    onClick={() => setActiveTab("Notifications")}
                                    className={`flex items-center space-x-2 px-4 py-2 rounded-md font-medium text-sm transition-colors ${
                                        activeTab === "Notifications"
                                            ? "bg-white text-gray-900 shadow-sm"
                                            : "text-gray-600 hover:text-gray-900"
                                    }`}
                                >
                                    <i className="fa fa-bell"></i>
                                    <span>{t("accountSettings.tabs.notifications")}</span>
                                </button>
                                <button
                                    onClick={() => setActiveTab("Privacy")}
                                    className={`flex items-center space-x-2 px-4 py-2 rounded-md font-medium text-sm transition-colors ${
                                        activeTab === "Privacy"
                                            ? "bg-white text-gray-900 shadow-sm"
                                            : "text-gray-600 hover:text-gray-900"
                                    }`}
                                >
                                    <i className="fa fa-eye"></i>
                                    <span>{t("accountSettings.tabs.privacy")}</span>
                                </button>
                                <button
                                    onClick={() => setActiveTab("Account")}
                                    className={`flex items-center space-x-2 px-4 py-2 rounded-md font-medium text-sm transition-colors ${
                                        activeTab === "Account"
                                            ? "bg-white text-gray-900 shadow-sm"
                                            : "text-gray-600 hover:text-gray-900"
                                    }`}
                                >
                                    <i className="fa fa-cog"></i>
                                    <span>{t("accountSettings.tabs.account")}</span>
                                </button>
                            </nav>
                        </div>

                        {activeTab === "Profile" && (
                            <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8">
                                <div className="mb-6">
                                    <h2 className="text-xl font-semibold text-gray-900 mb-1">{t("accountSettings.profile.sectionTitle")}</h2>
                                    <p className="text-sm text-gray-600">{t("accountSettings.profile.sectionSubtitle")}</p>
                                </div>

                                <form onSubmit={handleSubmit} className="space-y-6">
                                    <div className="flex items-start space-x-6">
                                        <div className="flex-shrink-0">
                                            {profileImage ? (
                                                <img 
                                                    src={profileImage} 
                                                    alt={t("accountSettings.profile.avatarAlt")} 
                                                    className="w-20 h-20 rounded-full object-cover"
                                                />
                                            ) : (
                                                <div className="w-20 h-20 rounded-full bg-gray-200 flex items-center justify-center">
                                                    <span className="text-gray-400 text-2xl">?</span>
                                                </div>
                                            )}
                                        </div>
                                        <div className="flex-1">
                                            <button
                                                type="button"
                                                onClick={() => document.getElementById('profile-image-input').click()}
                                                className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
                                            >
                                                {t("accountSettings.profile.changePhoto")}
                                            </button>
                                            <input
                                                id="profile-image-input"
                                                type="file"
                                                accept="image/*"
                                                onChange={handleImageChange}
                                                className="hidden"
                                            />
                                            <p className="mt-2 text-xs text-gray-500">{t("accountSettings.profile.photoHint")}</p>
                                        </div>
                                    </div>

                                    <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
                                        <div>
                                            <label htmlFor="first-name" className="block text-sm font-medium text-gray-700 mb-1">
                                                {t("accountSettings.profile.labels.firstName")}
                                            </label>
                                            <input
                                                type="text"
                                                id="first-name"
                                                value={firstName}
                                                onChange={(e) => setFirstName(e.target.value)}
                                                className="w-full px-3 py-2 bg-gray-50 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-gray-500 focus:border-gray-500"
                                                required
                                            />
                                        </div>

                                        <div>
                                            <label htmlFor="last-name" className="block text-sm font-medium text-gray-700 mb-1">
                                                {t("accountSettings.profile.labels.lastName")}
                                            </label>
                                            <input
                                                type="text"
                                                id="last-name"
                                                value={lastName}
                                                onChange={(e) => setLastName(e.target.value)}
                                                className="w-full px-3 py-2 bg-gray-50 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-gray-500 focus:border-gray-500"
                                                required
                                            />
                                        </div>
                                    </div>

                                    <div>
                                        <label htmlFor="username" className="block text-sm font-medium text-gray-700 mb-1">
                                            {t("accountSettings.profile.labels.username")}
                                        </label>
                                        <input
                                            type="text"
                                            id="username"
                                            value={getUsername()}
                                            disabled
                                            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm bg-gray-50 text-gray-500 cursor-not-allowed"
                                        />
                                    </div>

                                    <div>
                                        <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
                                            {t("accountSettings.profile.labels.email")}
                                        </label>
                                        <input
                                            type="email"
                                            id="email"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            className="w-full px-3 py-2 bg-gray-50 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-gray-500 focus:border-gray-500"
                                            required
                                        />
                                    </div>

                                    <div>
                                        <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1">
                                            {t("accountSettings.profile.labels.phone")}
                                        </label>
                                        <input
                                            type="tel"
                                            id="phone"
                                            value={phoneNumber}
                                            onChange={(e) => setPhoneNumber(e.target.value)}
                                            placeholder={t("accountSettings.profile.placeholders.phone")}
                                            className="w-full px-3 py-2 bg-gray-50 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-gray-500 focus:border-gray-500"
                                        />
                                    </div>

                                    <div>
                                        <label htmlFor="bio" className="block text-sm font-medium text-gray-700 mb-1">
                                            {t("accountSettings.profile.labels.bio")}
                                        </label>
                                        <textarea
                                            id="bio"
                                            rows={4}
                                            value={bio}
                                            onChange={(e) => setBio(e.target.value)}
                                            placeholder={t("accountSettings.profile.placeholders.bio")}
                                            className="w-full px-3 py-2 bg-gray-50 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-gray-500 focus:border-gray-500"
                                        />
                                        <p className="mt-1 text-xs text-gray-500">{t("accountSettings.profile.bioHelp")}</p>
                                    </div>

                                    <div>
                                        <label htmlFor="location" className="block text-sm font-medium text-gray-700 mb-1">
                                            {t("accountSettings.profile.labels.location")}
                                        </label>
                                        <input
                                            type="text"
                                            id="location"
                                            value={location}
                                            onChange={(e) => setLocation(e.target.value)}
                                            placeholder={t("accountSettings.profile.placeholders.location")}
                                            className="w-full px-3 py-2 bg-gray-50 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-gray-500 focus:border-gray-500"
                                        />
                                    </div>

                                    <div>
                                        <label htmlFor="website" className="block text-sm font-medium text-gray-700 mb-1">
                                            {t("accountSettings.profile.labels.website")}
                                        </label>
                                        <input
                                            type="url"
                                            id="website"
                                            value={website}
                                            onChange={(e) => setWebsite(e.target.value)}
                                            placeholder={t("accountSettings.profile.placeholders.website")}
                                            className="w-full px-3 py-2 bg-gray-50 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-gray-500 focus:border-gray-500"
                                        />
                                    </div>

                                    {error && (
                                        <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-md">
                                            {error}
                                        </div>
                                    )}

                                    {success && (
                                        <div className="bg-green-50 border border-green-200 text-green-700 px-4 py-3 rounded-md">
                                            {success}
                                        </div>
                                    )}

                                    <div className="flex justify-end space-x-3 pt-4">
                                        <button
                                            type="button"
                                            onClick={handleCancel}
                                            className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
                                        >
                                            {t("accountSettings.profile.cancel")}
                                        </button>
                                        <button
                                            type="submit"
                                            className="px-4 py-2 text-sm font-medium text-white bg-gray-900 rounded-md hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
                                        >
                                            {t("accountSettings.profile.saveChanges")}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        )}

                        {activeTab === "Password" && (
                            <div className="space-y-8">
                                {/* Change Password Section */}
                                <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8">
                                    <div className="mb-6">
                                        <h2 className="text-xl font-semibold text-gray-900 mb-1">{t("accountSettings.password.changeTitle")}</h2>
                                        <p className="text-sm text-gray-600">{t("accountSettings.password.changeSubtitle")}</p>
                                    </div>

                                    <form onSubmit={handlePasswordChange} className="space-y-6">
                                        <div>
                                            <label htmlFor="current-password" className="block text-sm font-medium text-gray-700 mb-1">
                                                {t("accountSettings.password.currentPassword")}
                                            </label>
                                            <div className="relative">
                                                <input
                                                    type={showCurrentPassword ? "text" : "password"}
                                                    id="current-password"
                                                    value={currentPassword}
                                                    onChange={(e) => setCurrentPassword(e.target.value)}
                                                    placeholder={t("accountSettings.password.placeholderCurrent")}
                                                    className="w-full px-3 py-2 pr-10 bg-gray-50 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-gray-500 focus:border-gray-500"
                                                />
                                                <button
                                                    type="button"
                                                    onClick={() => setShowCurrentPassword(!showCurrentPassword)}
                                                    className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600"
                                                >
                                                    <i className={showCurrentPassword ? "fa fa-eye-slash" : "fa fa-eye"}></i>
                                                </button>
                                            </div>
                                        </div>

                                        <div>
                                            <label htmlFor="new-password" className="block text-sm font-medium text-gray-700 mb-1">
                                                {t("accountSettings.password.newPassword")}
                                            </label>
                                            <div className="relative">
                                                <input
                                                    type={showNewPassword ? "text" : "password"}
                                                    id="new-password"
                                                    value={newPassword}
                                                    onChange={(e) => setNewPassword(e.target.value)}
                                                    placeholder={t("accountSettings.password.placeholderNew")}
                                                    className="w-full px-3 py-2 pr-10 bg-gray-50 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-gray-500 focus:border-gray-500"
                                                />
                                                <button
                                                    type="button"
                                                    onClick={() => setShowNewPassword(!showNewPassword)}
                                                    className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600"
                                                >
                                                    <i className={showNewPassword ? "fa fa-eye-slash" : "fa fa-eye"}></i>
                                                </button>
                                            </div>
                                        </div>

                                        <div>
                                            <label htmlFor="confirm-password" className="block text-sm font-medium text-gray-700 mb-1">
                                                {t("accountSettings.password.confirmNewPassword")}
                                            </label>
                                            <div className="relative">
                                                <input
                                                    type={showConfirmPassword ? "text" : "password"}
                                                    id="confirm-password"
                                                    value={confirmNewPassword}
                                                    onChange={(e) => setConfirmNewPassword(e.target.value)}
                                                    placeholder={t("accountSettings.password.placeholderConfirm")}
                                                    className="w-full px-3 py-2 pr-10 bg-gray-50 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-gray-500 focus:border-gray-500"
                                                />
                                                <button
                                                    type="button"
                                                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                                    className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600"
                                                >
                                                    <i className={showConfirmPassword ? "fa fa-eye-slash" : "fa fa-eye"}></i>
                                                </button>
                                            </div>
                                        </div>

                                        <div className="flex items-start space-x-2">
                                            <i className="fa fa-info-circle text-gray-400 mt-0.5"></i>
                                            <p className="text-sm text-gray-600">
                                                {t("accountSettings.password.strengthHelp")}
                                            </p>
                                        </div>

                                        {passwordError && (
                                            <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-md">
                                                {passwordError}
                                            </div>
                                        )}

                                        {passwordSuccess && (
                                            <div className="bg-green-50 border border-green-200 text-green-700 px-4 py-3 rounded-md">
                                                {passwordSuccess}
                                            </div>
                                        )}

                                        <div className="flex justify-end space-x-3 pt-4">
                                            <button
                                                type="button"
                                                onClick={handlePasswordCancel}
                                                className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
                                            >
                                                {t("accountSettings.password.cancel")}
                                            </button>
                                            <button
                                                type="submit"
                                                className="px-4 py-2 text-sm font-medium text-white bg-gray-900 rounded-md hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
                                            >
                                                {t("accountSettings.password.updatePassword")}
                                            </button>
                                        </div>
                                    </form>
                                </div>

                                {/* Password Reset Section */}
                                <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8">
                                    <div className="mb-6">
                                        <h2 className="text-xl font-semibold text-gray-900 mb-1">{t("accountSettings.passwordReset.title")}</h2>
                                        <p className="text-sm text-gray-600">{t("accountSettings.passwordReset.subtitle")}</p>
                                    </div>

                                    {resetSuccess && (
                                        <div className="mb-4 bg-green-50 border border-green-200 text-green-700 px-4 py-3 rounded-md">
                                            {resetSuccess}
                                        </div>
                                    )}

                                    <button
                                        type="button"
                                        onClick={handlePasswordReset}
                                        className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
                                    >
                                        {t("accountSettings.passwordReset.sendLink")}
                                    </button>
                                </div>
                            </div>
                        )}

                        {activeTab === "Security" && (
                            <div className="space-y-8">
                                <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8">
                                    <div className="mb-6">
                                        <h2 className="text-xl font-semibold text-gray-900 mb-1">{t("accountSettings.security.twoFactorTitle")}</h2>
                                        <p className="text-sm text-gray-600">{t("accountSettings.security.twoFactorSubtitle")}</p>
                                    </div>

                                    <div className="flex items-center justify-between py-4 border-b border-gray-200 last:border-b-0">
                                        <div className="flex-1">
                                            <div className="font-medium text-gray-900 mb-1">{t("accountSettings.security.enable2FA")}</div>
                                            <p className="text-sm text-gray-600">{t("accountSettings.security.enable2FADesc")}</p>
                                        </div>
                                        <div className="ml-4">
                                            <button
                                                type="button"
                                                onClick={() => setEnable2FA(!enable2FA)}
                                                className={`relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 ${enable2FA ? 'bg-gray-900' : 'bg-gray-200'}`}
                                            >
                                                <span className={`${enable2FA ? 'translate-x-5' : 'translate-x-0'} pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out`}></span>
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8">
                                    <div className="mb-6">
                                        <h2 className="text-xl font-semibold text-gray-900 mb-1">{t("accountSettings.security.loginAlertsTitle")}</h2>
                                        <p className="text-sm text-gray-600">{t("accountSettings.security.loginAlertsSubtitle")}</p>
                                    </div>

                                    <div className="flex items-center justify-between py-4 border-b border-gray-200 last:border-b-0">
                                        <div className="flex-1">
                                            <div className="font-medium text-gray-900 mb-1">{t("accountSettings.security.emailNewLogins")}</div>
                                            <p className="text-sm text-gray-600">{t("accountSettings.security.emailNewLoginsDesc")}</p>
                                        </div>
                                        <div className="ml-4">
                                            <button
                                                type="button"
                                                onClick={() => setLoginAlerts(!loginAlerts)}
                                                className={`relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 ${loginAlerts ? 'bg-gray-900' : 'bg-gray-200'}`}
                                            >
                                                <span className={`${loginAlerts ? 'translate-x-5' : 'translate-x-0'} pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out`}></span>
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8">
                                    <div className="mb-6">
                                        <h2 className="text-xl font-semibold text-gray-900 mb-1">{t("accountSettings.security.activeSessionsTitle")}</h2>
                                        <p className="text-sm text-gray-600">{t("accountSettings.security.activeSessionsSubtitle")}</p>
                                    </div>

                                    <div className="space-y-4">
                                        <div className="flex items-center justify-between p-4 border border-gray-200 rounded-lg">
                                            <div className="flex items-center space-x-4 flex-1">
                                                <div className="flex-shrink-0">
                                                    <i className="fa fa-laptop text-gray-400 text-2xl"></i>
                                                </div>
                                                <div className="flex-1">
                                                    <div className="flex items-center space-x-2 mb-1">
                                                        <span className="font-medium text-gray-900">MacBook Pro</span>
                                                        <span className="px-2 py-0.5 text-xs font-medium text-gray-600 bg-gray-100 rounded">{t("accountSettings.security.current")}</span>
                                                    </div>
                                                    <p className="text-sm text-gray-600">San Francisco, CA ÔÇó 192.168.1.1</p>
                                                    <p className="text-sm text-gray-500 mt-1">{t("accountSettings.security.lastActive1")}</p>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="flex items-center justify-between p-4 border border-gray-200 rounded-lg">
                                            <div className="flex items-center space-x-4 flex-1">
                                                <div className="flex-shrink-0">
                                                    <i className="fa fa-mobile-alt text-gray-400 text-2xl"></i>
                                                </div>
                                                <div className="flex-1">
                                                    <div className="font-medium text-gray-900 mb-1">iPhone 14 Pro</div>
                                                    <p className="text-sm text-gray-600">San Francisco, CA ÔÇó 192.168.1.2</p>
                                                    <p className="text-sm text-gray-500 mt-1">{t("accountSettings.security.lastActive2")}</p>
                                                </div>
                                            </div>
                                            <button
                                                type="button"
                                                className="ml-4 text-sm font-medium text-gray-700 hover:text-gray-900"
                                            >
                                                {t("accountSettings.security.revoke")}
                                            </button>
                                        </div>

                                        <div className="flex items-center justify-between p-4 border border-gray-200 rounded-lg">
                                            <div className="flex items-center space-x-4 flex-1">
                                                <div className="flex-shrink-0">
                                                    <i className="fa fa-tablet-alt text-gray-400 text-2xl"></i>
                                                </div>
                                                <div className="flex-1">
                                                    <div className="font-medium text-gray-900 mb-1">iPad Air</div>
                                                    <p className="text-sm text-gray-600">Oakland, CA ÔÇó 192.168.2.1</p>
                                                    <p className="text-sm text-gray-500 mt-1">{t("accountSettings.security.lastActive3")}</p>
                                                </div>
                                            </div>
                                            <button
                                                type="button"
                                                className="ml-4 text-sm font-medium text-gray-700 hover:text-gray-900"
                                            >
                                                {t("accountSettings.security.revoke")}
                                            </button>
                                        </div>
                                    </div>

                                    <div className="mt-6">
                                        <button
                                            type="button"
                                            className="px-4 py-2 text-sm font-medium text-white bg-gray-900 rounded-md hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
                                        >
                                            {t("accountSettings.security.revokeAll")}
                                        </button>
                                    </div>
                                </div>

                                <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8">
                                    <div className="mb-6">
                                        <h2 className="text-xl font-semibold text-gray-900 mb-1">{t("accountSettings.security.loginHistoryTitle")}</h2>
                                        <p className="text-sm text-gray-600">{t("accountSettings.security.loginHistorySubtitle")}</p>
                                    </div>

                                    <button
                                        type="button"
                                        className="text-sm font-medium text-gray-700 hover:text-gray-900"
                                    >
                                        {t("accountSettings.security.viewLoginHistory")}
                                    </button>
                                </div>
                            </div>
                        )}

                        {activeTab === "Notifications" && (
                            <div className="space-y-8">
                                <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8">
                                    <div className="mb-6">
                                        <h2 className="text-xl font-semibold text-gray-900 mb-1">{t("accountSettings.notifications.emailTitle")}</h2>
                                        <p className="text-sm text-gray-600">{t("accountSettings.notifications.emailSubtitle")}</p>
                                    </div>

                                    <div className="space-y-4">
                                        <div className="flex items-center justify-between py-3 border-b border-gray-200 last:border-b-0">
                                            <div className="flex-1">
                                                <div className="font-medium text-gray-900 mb-1">{t("accountSettings.notifications.productUpdates")}</div>
                                                <p className="text-sm text-gray-600">{t("accountSettings.notifications.productUpdatesDesc")}</p>
                                            </div>
                                            <div className="ml-4">
                                                <button
                                                    type="button"
                                                    onClick={() => setEmailProductUpdates(!emailProductUpdates)}
                                                    className={`relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 ${emailProductUpdates ? 'bg-gray-900' : 'bg-gray-200'}`}
                                                >
                                                    <span className={`${emailProductUpdates ? 'translate-x-5' : 'translate-x-0'} pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out`}></span>
                                                </button>
                                            </div>
                                        </div>

                                        <div className="flex items-center justify-between py-3 border-b border-gray-200 last:border-b-0">
                                            <div className="flex-1">
                                                <div className="font-medium text-gray-900 mb-1">{t("accountSettings.notifications.securityAlerts")}</div>
                                                <p className="text-sm text-gray-600">{t("accountSettings.notifications.securityAlertsDesc")}</p>
                                            </div>
                                            <div className="ml-4">
                                                <button
                                                    type="button"
                                                    onClick={() => setEmailSecurityAlerts(!emailSecurityAlerts)}
                                                    className={`relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 ${emailSecurityAlerts ? 'bg-gray-900' : 'bg-gray-200'}`}
                                                >
                                                    <span className={`${emailSecurityAlerts ? 'translate-x-5' : 'translate-x-0'} pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out`}></span>
                                                </button>
                                            </div>
                                        </div>

                                        <div className="flex items-center justify-between py-3 border-b border-gray-200 last:border-b-0">
                                            <div className="flex-1">
                                                <div className="font-medium text-gray-900 mb-1">{t("accountSettings.notifications.newsletter")}</div>
                                                <p className="text-sm text-gray-600">{t("accountSettings.notifications.newsletterDesc")}</p>
                                            </div>
                                            <div className="ml-4">
                                                <button
                                                    type="button"
                                                    onClick={() => setEmailNewsletter(!emailNewsletter)}
                                                    className={`relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 ${emailNewsletter ? 'bg-gray-900' : 'bg-gray-200'}`}
                                                >
                                                    <span className={`${emailNewsletter ? 'translate-x-5' : 'translate-x-0'} pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out`}></span>
                                                </button>
                                            </div>
                                        </div>

                                        <div className="flex items-center justify-between py-3 border-b border-gray-200 last:border-b-0">
                                            <div className="flex-1">
                                                <div className="font-medium text-gray-900 mb-1">{t("accountSettings.notifications.comments")}</div>
                                                <p className="text-sm text-gray-600">{t("accountSettings.notifications.commentsDesc")}</p>
                                            </div>
                                            <div className="ml-4">
                                                <button
                                                    type="button"
                                                    onClick={() => setEmailComments(!emailComments)}
                                                    className={`relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 ${emailComments ? 'bg-gray-900' : 'bg-gray-200'}`}
                                                >
                                                    <span className={`${emailComments ? 'translate-x-5' : 'translate-x-0'} pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out`}></span>
                                                </button>
                                            </div>
                                        </div>

                                        <div className="flex items-center justify-between py-3 border-b border-gray-200 last:border-b-0">
                                            <div className="flex-1">
                                                <div className="font-medium text-gray-900 mb-1">{t("accountSettings.notifications.mentions")}</div>
                                                <p className="text-sm text-gray-600">{t("accountSettings.notifications.mentionsDesc")}</p>
                                            </div>
                                            <div className="ml-4">
                                                <button
                                                    type="button"
                                                    onClick={() => setEmailMentions(!emailMentions)}
                                                    className={`relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 ${emailMentions ? 'bg-gray-900' : 'bg-gray-200'}`}
                                                >
                                                    <span className={`${emailMentions ? 'translate-x-5' : 'translate-x-0'} pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out`}></span>
                                                </button>
                                            </div>
                                        </div>

                                        <div className="flex items-center justify-between py-3 border-b border-gray-200 last:border-b-0">
                                            <div className="flex-1">
                                                <div className="font-medium text-gray-900 mb-1">{t("accountSettings.notifications.newFollowers")}</div>
                                                <p className="text-sm text-gray-600">{t("accountSettings.notifications.newFollowersDesc")}</p>
                                            </div>
                                            <div className="ml-4">
                                                <button
                                                    type="button"
                                                    onClick={() => setEmailNewFollowers(!emailNewFollowers)}
                                                    className={`relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 ${emailNewFollowers ? 'bg-gray-900' : 'bg-gray-200'}`}
                                                >
                                                    <span className={`${emailNewFollowers ? 'translate-x-5' : 'translate-x-0'} pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out`}></span>
                                                </button>
                                            </div>
                                        </div>

                                        <div className="flex items-center justify-between py-3 border-b border-gray-200 last:border-b-0">
                                            <div className="flex-1">
                                                <div className="font-medium text-gray-900 mb-1">{t("accountSettings.notifications.directMessages")}</div>
                                                <p className="text-sm text-gray-600">{t("accountSettings.notifications.directMessagesDesc")}</p>
                                            </div>
                                            <div className="ml-4">
                                                <button
                                                    type="button"
                                                    onClick={() => setEmailDirectMessages(!emailDirectMessages)}
                                                    className={`relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 ${emailDirectMessages ? 'bg-gray-900' : 'bg-gray-200'}`}
                                                >
                                                    <span className={`${emailDirectMessages ? 'translate-x-5' : 'translate-x-0'} pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out`}></span>
                                                </button>
                                            </div>
                                        </div>

                                        <div className="flex items-center justify-between py-3 border-b border-gray-200 last:border-b-0">
                                            <div className="flex-1">
                                                <div className="font-medium text-gray-900 mb-1">{t("accountSettings.notifications.tipsTutorials")}</div>
                                                <p className="text-sm text-gray-600">{t("accountSettings.notifications.tipsTutorialsDesc")}</p>
                                            </div>
                                            <div className="ml-4">
                                                <button
                                                    type="button"
                                                    onClick={() => setEmailTipsTutorials(!emailTipsTutorials)}
                                                    className={`relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 ${emailTipsTutorials ? 'bg-gray-900' : 'bg-gray-200'}`}
                                                >
                                                    <span className={`${emailTipsTutorials ? 'translate-x-5' : 'translate-x-0'} pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out`}></span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8">
                                    <div className="mb-6">
                                        <h2 className="text-xl font-semibold text-gray-900 mb-1">{t("accountSettings.notifications.pushTitle")}</h2>
                                        <p className="text-sm text-gray-600">{t("accountSettings.notifications.pushSubtitle")}</p>
                                    </div>

                                    <div className="space-y-4">
                                        <div className="flex items-center justify-between py-3 border-b border-gray-200 last:border-b-0">
                                            <div className="flex-1">
                                                <div className="font-medium text-gray-900 mb-1">{t("accountSettings.notifications.pushMessages")}</div>
                                                <p className="text-sm text-gray-600">{t("accountSettings.notifications.pushMessagesDesc")}</p>
                                            </div>
                                            <div className="ml-4">
                                                <button
                                                    type="button"
                                                    onClick={() => setPushMessages(!pushMessages)}
                                                    className={`relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 ${pushMessages ? 'bg-gray-900' : 'bg-gray-200'}`}
                                                >
                                                    <span className={`${pushMessages ? 'translate-x-5' : 'translate-x-0'} pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out`}></span>
                                                </button>
                                            </div>
                                        </div>

                                        <div className="flex items-center justify-between py-3 border-b border-gray-200 last:border-b-0">
                                            <div className="flex-1">
                                                <div className="font-medium text-gray-900 mb-1">{t("accountSettings.notifications.pushComments")}</div>
                                                <p className="text-sm text-gray-600">{t("accountSettings.notifications.pushCommentsDesc")}</p>
                                            </div>
                                            <div className="ml-4">
                                                <button
                                                    type="button"
                                                    onClick={() => setPushComments(!pushComments)}
                                                    className={`relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 ${pushComments ? 'bg-gray-900' : 'bg-gray-200'}`}
                                                >
                                                    <span className={`${pushComments ? 'translate-x-5' : 'translate-x-0'} pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out`}></span>
                                                </button>
                                            </div>
                                        </div>

                                        <div className="flex items-center justify-between py-3 border-b border-gray-200 last:border-b-0">
                                            <div className="flex-1">
                                                <div className="font-medium text-gray-900 mb-1">{t("accountSettings.notifications.pushMentions")}</div>
                                                <p className="text-sm text-gray-600">{t("accountSettings.notifications.pushMentionsDesc")}</p>
                                            </div>
                                            <div className="ml-4">
                                                <button
                                                    type="button"
                                                    onClick={() => setPushMentions(!pushMentions)}
                                                    className={`relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 ${pushMentions ? 'bg-gray-900' : 'bg-gray-200'}`}
                                                >
                                                    <span className={`${pushMentions ? 'translate-x-5' : 'translate-x-0'} pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out`}></span>
                                                </button>
                                            </div>
                                        </div>

                                        <div className="flex items-center justify-between py-3 border-b border-gray-200 last:border-b-0">
                                            <div className="flex-1">
                                                <div className="font-medium text-gray-900 mb-1">{t("accountSettings.notifications.pushNewFollowers")}</div>
                                                <p className="text-sm text-gray-600">{t("accountSettings.notifications.pushNewFollowersDesc")}</p>
                                            </div>
                                            <div className="ml-4">
                                                <button
                                                    type="button"
                                                    onClick={() => setPushNewFollowers(!pushNewFollowers)}
                                                    className={`relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 ${pushNewFollowers ? 'bg-gray-900' : 'bg-gray-200'}`}
                                                >
                                                    <span className={`${pushNewFollowers ? 'translate-x-5' : 'translate-x-0'} pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out`}></span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8">
                                    <div className="mb-6">
                                        <h2 className="text-xl font-semibold text-gray-900 mb-1">{t("accountSettings.notifications.smsTitle")}</h2>
                                        <p className="text-sm text-gray-600">{t("accountSettings.notifications.smsSubtitle")}</p>
                                    </div>

                                    <div className="space-y-4">
                                        <div className="flex items-center justify-between py-3 border-b border-gray-200 last:border-b-0">
                                            <div className="flex-1">
                                                <div className="font-medium text-gray-900 mb-1">{t("accountSettings.notifications.smsSecurityAlerts")}</div>
                                                <p className="text-sm text-gray-600">{t("accountSettings.notifications.smsSecurityAlertsDesc")}</p>
                                            </div>
                                            <div className="ml-4">
                                                <button
                                                    type="button"
                                                    onClick={() => setSmsSecurityAlerts(!smsSecurityAlerts)}
                                                    className={`relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 ${smsSecurityAlerts ? 'bg-gray-900' : 'bg-gray-200'}`}
                                                >
                                                    <span className={`${smsSecurityAlerts ? 'translate-x-5' : 'translate-x-0'} pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out`}></span>
                                                </button>
                                            </div>
                                        </div>

                                        <div className="flex items-center justify-between py-3 border-b border-gray-200 last:border-b-0">
                                            <div className="flex-1">
                                                <div className="font-medium text-gray-900 mb-1">{t("accountSettings.notifications.smsLoginAttempts")}</div>
                                                <p className="text-sm text-gray-600">{t("accountSettings.notifications.smsLoginAttemptsDesc")}</p>
                                            </div>
                                            <div className="ml-4">
                                                <button
                                                    type="button"
                                                    onClick={() => setSmsLoginAttempts(!smsLoginAttempts)}
                                                    className={`relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 ${smsLoginAttempts ? 'bg-gray-900' : 'bg-gray-200'}`}
                                                >
                                                    <span className={`${smsLoginAttempts ? 'translate-x-5' : 'translate-x-0'} pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out`}></span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {success && (
                                    <div className="bg-green-50 border border-green-200 text-green-700 px-4 py-3 rounded-md">
                                        {success}
                                    </div>
                                )}

                                <div className="flex justify-between pt-4">
                                    <button
                                        type="button"
                                        onClick={resetNotificationDefaults}
                                        className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
                                    >
                                        {t("accountSettings.notifications.resetToDefault")}
                                    </button>
                                    <button
                                        type="button"
                                        onClick={handleSavePreferences}
                                        className="px-4 py-2 text-sm font-medium text-white bg-gray-900 rounded-md hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
                                    >
                                        {t("accountSettings.notifications.savePreferences")}
                                    </button>
                                </div>
                            </div>
                        )}

                        {activeTab === "Privacy" && (
                            <div className="space-y-8">
                                <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8">
                                    <div className="mb-6">
                                        <h2 className="text-xl font-semibold text-gray-900 mb-1">{t("accountSettings.privacy.visibilityTitle")}</h2>
                                        <p className="text-sm text-gray-600">{t("accountSettings.privacy.visibilitySubtitle")}</p>
                                    </div>

                                    <div className="space-y-4">
                                        <label className="flex items-start space-x-3 cursor-pointer">
                                            <input
                                                type="radio"
                                                name="profileVisibility"
                                                value="public"
                                                checked={profileVisibility === "public"}
                                                onChange={(e) => setProfileVisibility(e.target.value)}
                                                className="mt-1 h-4 w-4 text-gray-900 focus:ring-gray-500"
                                            />
                                            <div className="flex-1">
                                                <div className="font-medium text-gray-900">{t("accountSettings.privacy.public")}</div>
                                                <p className="text-sm text-gray-600">{t("accountSettings.privacy.publicDesc")}</p>
                                            </div>
                                        </label>

                                        <label className="flex items-start space-x-3 cursor-pointer">
                                            <input
                                                type="radio"
                                                name="profileVisibility"
                                                value="friends"
                                                checked={profileVisibility === "friends"}
                                                onChange={(e) => setProfileVisibility(e.target.value)}
                                                className="mt-1 h-4 w-4 text-gray-900 focus:ring-gray-500"
                                            />
                                            <div className="flex-1">
                                                <div className="font-medium text-gray-900">{t("accountSettings.privacy.friendsOnly")}</div>
                                                <p className="text-sm text-gray-600">{t("accountSettings.privacy.friendsOnlyDesc")}</p>
                                            </div>
                                        </label>

                                        <label className="flex items-start space-x-3 cursor-pointer">
                                            <input
                                                type="radio"
                                                name="profileVisibility"
                                                value="private"
                                                checked={profileVisibility === "private"}
                                                onChange={(e) => setProfileVisibility(e.target.value)}
                                                className="mt-1 h-4 w-4 text-gray-900 focus:ring-gray-500"
                                            />
                                            <div className="flex-1">
                                                <div className="font-medium text-gray-900">{t("accountSettings.privacy.private")}</div>
                                                <p className="text-sm text-gray-600">{t("accountSettings.privacy.privateDesc")}</p>
                                            </div>
                                        </label>
                                    </div>
                                </div>

                                <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8">
                                    <div className="mb-6">
                                        <h2 className="text-xl font-semibold text-gray-900 mb-1">{t("accountSettings.privacy.activityTitle")}</h2>
                                        <p className="text-sm text-gray-600">{t("accountSettings.privacy.activitySubtitle")}</p>
                                    </div>

                                    <div className="space-y-4">
                                        <div className="flex items-center justify-between py-3 border-b border-gray-200 last:border-b-0">
                                            <div className="flex-1">
                                                <div className="font-medium text-gray-900 mb-1">{t("accountSettings.privacy.showActivity")}</div>
                                                <p className="text-sm text-gray-600">{t("accountSettings.privacy.showActivityDesc")}</p>
                                            </div>
                                            <div className="ml-4">
                                                <button
                                                    type="button"
                                                    onClick={() => setShowActivityStatus(!showActivityStatus)}
                                                    className={`relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 ${showActivityStatus ? 'bg-gray-900' : 'bg-gray-200'}`}
                                                >
                                                    <span className={`${showActivityStatus ? 'translate-x-5' : 'translate-x-0'} pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out`}></span>
                                                </button>
                                            </div>
                                        </div>

                                        <div className="flex items-center justify-between py-3 border-b border-gray-200 last:border-b-0">
                                            <div className="flex-1">
                                                <div className="font-medium text-gray-900 mb-1">{t("accountSettings.privacy.readReceipts")}</div>
                                                <p className="text-sm text-gray-600">{t("accountSettings.privacy.readReceiptsDesc")}</p>
                                            </div>
                                            <div className="ml-4">
                                                <button
                                                    type="button"
                                                    onClick={() => setReadReceipts(!readReceipts)}
                                                    className={`relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 ${readReceipts ? 'bg-gray-900' : 'bg-gray-200'}`}
                                                >
                                                    <span className={`${readReceipts ? 'translate-x-5' : 'translate-x-0'} pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out`}></span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8">
                                    <div className="mb-6">
                                        <h2 className="text-xl font-semibold text-gray-900 mb-1">{t("accountSettings.privacy.discoverabilityTitle")}</h2>
                                        <p className="text-sm text-gray-600">{t("accountSettings.privacy.discoverabilitySubtitle")}</p>
                                    </div>

                                    <div className="space-y-4">
                                        <div className="flex items-center justify-between py-3 border-b border-gray-200 last:border-b-0">
                                            <div className="flex-1">
                                                <div className="font-medium text-gray-900 mb-1">{t("accountSettings.privacy.searchableProfile")}</div>
                                                <p className="text-sm text-gray-600">{t("accountSettings.privacy.searchableProfileDesc")}</p>
                                            </div>
                                            <div className="ml-4">
                                                <button
                                                    type="button"
                                                    onClick={() => setSearchableProfile(!searchableProfile)}
                                                    className={`relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 ${searchableProfile ? 'bg-gray-900' : 'bg-gray-200'}`}
                                                >
                                                    <span className={`${searchableProfile ? 'translate-x-5' : 'translate-x-0'} pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out`}></span>
                                                </button>
                                            </div>
                                        </div>

                                        <div className="flex items-center justify-between py-3 border-b border-gray-200 last:border-b-0">
                                            <div className="flex-1">
                                                <div className="font-medium text-gray-900 mb-1">{t("accountSettings.privacy.showEmail")}</div>
                                                <p className="text-sm text-gray-600">{t("accountSettings.privacy.showEmailDesc")}</p>
                                            </div>
                                            <div className="ml-4">
                                                <button
                                                    type="button"
                                                    onClick={() => setShowEmailAddress(!showEmailAddress)}
                                                    className={`relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 ${showEmailAddress ? 'bg-gray-900' : 'bg-gray-200'}`}
                                                >
                                                    <span className={`${showEmailAddress ? 'translate-x-5' : 'translate-x-0'} pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out`}></span>
                                                </button>
                                            </div>
                                        </div>

                                        <div className="flex items-center justify-between py-3 border-b border-gray-200 last:border-b-0">
                                            <div className="flex-1">
                                                <div className="font-medium text-gray-900 mb-1">{t("accountSettings.privacy.showPhone")}</div>
                                                <p className="text-sm text-gray-600">{t("accountSettings.privacy.showPhoneDesc")}</p>
                                            </div>
                                            <div className="ml-4">
                                                <button
                                                    type="button"
                                                    onClick={() => setShowPhoneNumber(!showPhoneNumber)}
                                                    className={`relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 ${showPhoneNumber ? 'bg-gray-900' : 'bg-gray-200'}`}
                                                >
                                                    <span className={`${showPhoneNumber ? 'translate-x-5' : 'translate-x-0'} pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out`}></span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8">
                                    <div className="mb-6">
                                        <h2 className="text-xl font-semibold text-gray-900 mb-1">{t("accountSettings.privacy.dataSharingTitle")}</h2>
                                        <p className="text-sm text-gray-600">{t("accountSettings.privacy.dataSharingSubtitle")}</p>
                                    </div>

                                    <div className="space-y-4">
                                        <div className="flex items-center justify-between py-3 border-b border-gray-200 last:border-b-0">
                                            <div className="flex-1">
                                                <div className="font-medium text-gray-900 mb-1">{t("accountSettings.privacy.analytics")}</div>
                                                <p className="text-sm text-gray-600">{t("accountSettings.privacy.analyticsDesc")}</p>
                                            </div>
                                            <div className="ml-4">
                                                <button
                                                    type="button"
                                                    onClick={() => setAnalytics(!analytics)}
                                                    className={`relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 ${analytics ? 'bg-gray-900' : 'bg-gray-200'}`}
                                                >
                                                    <span className={`${analytics ? 'translate-x-5' : 'translate-x-0'} pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out`}></span>
                                                </button>
                                            </div>
                                        </div>

                                        <div className="flex items-center justify-between py-3 border-b border-gray-200 last:border-b-0">
                                            <div className="flex-1">
                                                <div className="font-medium text-gray-900 mb-1">{t("accountSettings.privacy.marketing")}</div>
                                                <p className="text-sm text-gray-600">{t("accountSettings.privacy.marketingDesc")}</p>
                                            </div>
                                            <div className="ml-4">
                                                <button
                                                    type="button"
                                                    onClick={() => setMarketingCommunications(!marketingCommunications)}
                                                    className={`relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 ${marketingCommunications ? 'bg-gray-900' : 'bg-gray-200'}`}
                                                >
                                                    <span className={`${marketingCommunications ? 'translate-x-5' : 'translate-x-0'} pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out`}></span>
                                                </button>
                                            </div>
                                        </div>

                                        <div className="flex items-center justify-between py-3 border-b border-gray-200 last:border-b-0">
                                            <div className="flex-1">
                                                <div className="font-medium text-gray-900 mb-1">{t("accountSettings.privacy.thirdParty")}</div>
                                                <p className="text-sm text-gray-600">{t("accountSettings.privacy.thirdPartyDesc")}</p>
                                            </div>
                                            <div className="ml-4">
                                                <button
                                                    type="button"
                                                    onClick={() => setThirdPartySharing(!thirdPartySharing)}
                                                    className={`relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 ${thirdPartySharing ? 'bg-gray-900' : 'bg-gray-200'}`}
                                                >
                                                    <span className={`${thirdPartySharing ? 'translate-x-5' : 'translate-x-0'} pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out`}></span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8">
                                    <div className="mb-6">
                                        <h2 className="text-xl font-semibold text-gray-900 mb-1">{t("accountSettings.privacy.dataRightsTitle")}</h2>
                                        <p className="text-sm text-gray-600">{t("accountSettings.privacy.dataRightsSubtitle")}</p>
                                    </div>

                                    <div className="space-y-3">
                                        <button
                                            type="button"
                                            className="text-sm font-medium text-gray-700 hover:text-gray-900"
                                        >
                                            {t("accountSettings.privacy.downloadData")}
                                        </button>
                                        <div className="border-b border-gray-200"></div>
                                        <button
                                            type="button"
                                            className="text-sm font-medium text-gray-700 hover:text-gray-900"
                                        >
                                            {t("accountSettings.privacy.viewPolicy")}
                                        </button>
                                        <div className="border-b border-gray-200"></div>
                                        <button
                                            type="button"
                                            className="text-sm font-medium text-gray-700 hover:text-gray-900"
                                        >
                                            {t("accountSettings.privacy.requestReport")}
                                        </button>
                                    </div>
                                </div>

                                {success && (
                                    <div className="bg-green-50 border border-green-200 text-green-700 px-4 py-3 rounded-md">
                                        {success}
                                    </div>
                                )}

                                <div className="flex justify-end space-x-3 pt-4">
                                    <button
                                        type="button"
                                        onClick={resetPrivacyDefaults}
                                        className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
                                    >
                                        {t("accountSettings.privacy.cancel")}
                                    </button>
                                    <button
                                        type="button"
                                        onClick={handleSavePrivacyChanges}
                                        className="px-4 py-2 text-sm font-medium text-white bg-gray-900 rounded-md hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
                                    >
                                        {t("accountSettings.privacy.saveChanges")}
                                    </button>
                                </div>
                            </div>
                        )}

                        {activeTab === "Account" && (
                            <div className="space-y-8">
                                <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8">
                                    <div className="mb-6">
                                        <h2 className="text-xl font-semibold text-gray-900 mb-1">{t("accountSettings.account.infoTitle")}</h2>
                                        <p className="text-sm text-gray-600">{t("accountSettings.account.infoSubtitle")}</p>
                                    </div>

                                    <div className="space-y-4">
                                        <div className="flex items-center justify-between py-3 border-b border-gray-200">
                                            <div>
                                                <div className="text-sm text-gray-600 mb-1">{t("accountSettings.account.accountStatus")}</div>
                                                <div className="flex items-center space-x-2">
                                                    <span className="text-sm font-medium text-gray-900">{t("accountSettings.account.accountActive")}</span>
                                                    <span className="px-2 py-0.5 text-xs font-medium text-green-700 bg-green-100 rounded-full">{t("accountSettings.account.badgeActive")}</span>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="flex items-center justify-between py-3 border-b border-gray-200">
                                            <div>
                                                <div className="text-sm text-gray-600 mb-1">{t("accountSettings.account.memberSince")}</div>
                                                <div className="text-sm font-medium text-gray-900">January 15, 2023</div>
                                            </div>
                                        </div>

                                        <div className="flex items-center justify-between py-3">
                                            <div>
                                                <div className="text-sm text-gray-600 mb-1">{t("accountSettings.account.accountType")}</div>
                                                <div className="text-sm font-medium text-gray-900">Premium</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8">
                                    <div className="mb-6">
                                        <h2 className="text-xl font-semibold text-gray-900 mb-1">{t("accountSettings.account.preferencesTitle")}</h2>
                                        <p className="text-sm text-gray-600">{t("accountSettings.account.preferencesSubtitle")}</p>
                                    </div>

                                    <div className="space-y-6">
                                        <div>
                                            <label htmlFor="language" className="block text-sm font-medium text-gray-700 mb-2">
                                                {t("accountSettings.account.language")}
                                            </label>
                                            <div className="flex items-center gap-2">
                                                <button
                                                    type="button"
                                                    onClick={() => setAppLanguage("en")}
                                                    className={`px-4 py-2 text-sm rounded-md border transition-colors ${activeLang === "en" || activeLang.startsWith("en") ? "bg-gray-900 text-white border-gray-900" : "bg-gray-50 text-gray-700 border-gray-300 hover:bg-gray-100"}`}
                                                >
                                                    <img src="https://flagcdn.com/us.svg" alt="US" className="w-5 h-3.5 inline-block mr-1 rounded-sm" />EN
                                                </button>
                                                <button
                                                    type="button"
                                                    onClick={() => setAppLanguage("tr")}
                                                    className={`px-4 py-2 text-sm rounded-md border transition-colors ${activeLang === "tr" || activeLang.startsWith("tr") ? "bg-gray-900 text-white border-gray-900" : "bg-gray-50 text-gray-700 border-gray-300 hover:bg-gray-100"}`}
                                                >
                                                    <img src="https://flagcdn.com/tr.svg" alt="TR" className="w-5 h-3.5 inline-block mr-1 rounded-sm" />TR
                                                </button>
                                            </div>
                                        </div>

                                        <div>
                                            <label htmlFor="timezone-select" className="block text-sm font-medium text-gray-700 mb-2">
                                                {t("accountSettings.account.timezone")}
                                            </label>
                                            <select
                                                id="timezone-select"
                                                value={timezone}
                                                onChange={(e) => setTimezone(e.target.value)}
                                                className="w-full px-3 py-2 bg-gray-50 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-gray-500 focus:border-gray-500"
                                            >
                                                <option value="">{t("accountSettings.account.selectTimezone")}</option>
                                                <option value="Pacific Time (PST)">Pacific Time (PST)</option>
                                                <option value="Mountain Time (MST)">Mountain Time (MST)</option>
                                                <option value="Central Time (CST)">Central Time (CST)</option>
                                                <option value="Eastern Time (EST)">Eastern Time (EST)</option>
                                                <option value="GMT+1:00">GMT+1:00</option>
                                                <option value="GMT+2:00">GMT+2:00</option>
                                                <option value="GMT+3:00">GMT+3:00</option>
                                            </select>
                                        </div>

                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                                {t("accountSettings.account.theme")}
                                            </label>
                                            <div className="flex justify-between">
                                                <button
                                                    type="button"
                                                    onClick={() => setTheme("Light")}
                                                    className={`flex items-center justify-center space-x-2 px-4 py-2 text-sm font-medium rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 flex-1 ${
                                                        theme === "Light"
                                                            ? "bg-gray-900 text-white"
                                                            : "bg-white text-gray-700 border border-gray-300 hover:bg-gray-50"
                                                    }`}
                                                >
                                                    <i className={`fa ${theme === "Light" ? "fa-sun" : "fa-sun"} ${theme === "Light" ? "text-white" : "text-gray-600"}`}></i>
                                                    <span>{t("accountSettings.account.themeLight")}</span>
                                                </button>
                                                <button
                                                    type="button"
                                                    onClick={() => setTheme("Dark")}
                                                    className={`flex items-center justify-center space-x-2 px-4 py-2 text-sm font-medium rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 flex-1 mx-2 ${
                                                        theme === "Dark"
                                                            ? "bg-gray-900 text-white"
                                                            : "bg-white text-gray-700 border border-gray-300 hover:bg-gray-50"
                                                    }`}
                                                >
                                                    <i className={`fa ${theme === "Dark" ? "fa-moon text-white" : "fa-moon text-gray-600"}`}></i>
                                                    <span>{t("accountSettings.account.themeDark")}</span>
                                                </button>
                                                <button
                                                    type="button"
                                                    onClick={() => setTheme("Auto")}
                                                    className={`flex items-center justify-center space-x-2 px-4 py-2 text-sm font-medium rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 flex-1 ${
                                                        theme === "Auto"
                                                            ? "bg-gray-900 text-white"
                                                            : "bg-white text-gray-700 border border-gray-300 hover:bg-gray-50"
                                                    }`}
                                                >
                                                    <i className={`fa ${theme === "Auto" ? "fa-globe text-white" : "fa-globe text-gray-600"}`}></i>
                                                    <span>{t("accountSettings.account.themeAuto")}</span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8">
                                    <div className="mb-6">
                                        <h2 className="text-xl font-semibold text-gray-900 mb-1">{t("accountSettings.account.dataManagementTitle")}</h2>
                                        <p className="text-sm text-gray-600">{t("accountSettings.account.dataManagementSubtitle")}</p>
                                    </div>

                                    <button
                                        type="button"
                                        className="flex items-center space-x-2 px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
                                    >
                                        <i className="fa fa-download"></i>
                                        <span>{t("accountSettings.account.exportData")}</span>
                                    </button>
                                    <p className="mt-2 text-sm text-gray-600">{t("accountSettings.account.exportHelp")}</p>
                                </div>

                                <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8">
                                    <div className="mb-6">
                                        <h2 className="text-xl font-semibold text-gray-900 mb-1">{t("accountSettings.account.connectedTitle")}</h2>
                                        <p className="text-sm text-gray-600">{t("accountSettings.account.connectedSubtitle")}</p>
                                    </div>

                                    <div className="space-y-4">
                                        <div className="flex items-center justify-between py-4 border-b border-gray-200">
                                            <div className="flex items-center space-x-3">
                                                <div className="w-10 h-10 bg-white border border-gray-300 rounded-full flex items-center justify-center">
                                                    <span className="text-lg font-bold text-blue-600">G</span>
                                                </div>
                                                <div>
                                                    <div className="font-medium text-gray-900">Google</div>
                                                    <div className="text-sm text-gray-600">{googleConnected ? t("accountSettings.account.connected") : t("accountSettings.account.notConnected")}</div>
                                                </div>
                                            </div>
                                            <button
                                                type="button"
                                                onClick={() => setGoogleConnected(!googleConnected)}
                                                className="text-sm font-medium text-gray-700 hover:text-gray-900"
                                            >
                                                {googleConnected ? t("accountSettings.account.disconnect") : t("accountSettings.account.connect")}
                                            </button>
                                        </div>

                                        <div className="flex items-center justify-between py-4">
                                            <div className="flex items-center space-x-3">
                                                <div className="w-10 h-10 bg-gray-900 rounded-full flex items-center justify-center">
                                                    <i className="fa fa-github text-white"></i>
                                                </div>
                                                <div>
                                                    <div className="font-medium text-gray-900">GitHub</div>
                                                    <div className="text-sm text-gray-600">{githubConnected ? t("accountSettings.account.connected") : t("accountSettings.account.notConnected")}</div>
                                                </div>
                                            </div>
                                            <button
                                                type="button"
                                                onClick={() => setGithubConnected(!githubConnected)}
                                                className="text-sm font-medium text-gray-700 hover:text-gray-900"
                                            >
                                                {githubConnected ? t("accountSettings.account.disconnect") : t("accountSettings.account.connect")}
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <div className="bg-orange-50 rounded-lg shadow-sm border border-orange-200 p-8">
                                    <div className="mb-6">
                                        <h2 className="text-xl font-semibold text-gray-900 mb-1">{t("accountSettings.account.deactivateTitle")}</h2>
                                        <p className="text-sm text-gray-600">{t("accountSettings.account.deactivateSubtitle")}</p>
                                    </div>

                                    <button
                                        type="button"
                                        className="px-4 py-2 text-sm font-medium text-gray-900 bg-orange-100 border border-orange-300 rounded-md hover:bg-orange-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500"
                                    >
                                        {t("accountSettings.account.deactivate")}
                                    </button>
                                </div>

                                <div className="bg-red-50 rounded-lg shadow-sm border border-red-200 p-8">
                                    <div className="mb-6">
                                        <h2 className="text-xl font-semibold text-gray-900 mb-1">{t("accountSettings.account.deleteTitle")}</h2>
                                        <p className="text-sm text-gray-600">{t("accountSettings.account.deleteSubtitle")}</p>
                                    </div>

                                    <div className="mb-4">
                                        <button
                                            type="button"
                                            className="flex items-center space-x-2 px-4 py-2 text-sm font-medium text-white bg-red-600 rounded-md hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
                                        >
                                            <i className="fa fa-trash"></i>
                                            <span>{t("accountSettings.account.deleteButton")}</span>
                                        </button>
                                    </div>
                                    <p className="text-sm text-red-700">{t("accountSettings.account.deleteWarning")}</p>
                                </div>

                                <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mt-8">
                                    <div className="flex items-center justify-between">
                                        <div>
                                            <h3 className="text-lg font-semibold text-gray-900 mb-1">{t("accountSettings.account.logOutTitle")}</h3>
                                            <p className="text-sm text-gray-600">{t("accountSettings.account.logOutSubtitle")}</p>
                                        </div>
                                        <button
                                            type="button"
                                            onClick={handleLogOut}
                                            className="flex items-center space-x-2 px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
                                        >
                                            <span>{t("accountSettings.account.logOut")}</span>
                                            <i className="fa fa-arrow-right"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}

                        {activeTab !== "Profile" && activeTab !== "Password" && activeTab !== "Security" && activeTab !== "Notifications" && activeTab !== "Privacy" && activeTab !== "Account" && (
                            <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8">
                                <p className="text-gray-500">{t("accountSettings.comingSoon")}</p>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    ) : <Redirect to="/login" />;
}

const mapStateToProps = (state) => {
    return {
        token: state.auth.token,
        profile: state.profile.profile,
        profile_updated: state.profile.profile_updated,
        error_message: state.profile.error_message,
        settings: state.settings.settings,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getProfileFN: () => dispatch(getProfile()),
        updateProfileFN: (profile) => dispatch(updateProfile(profile)),
        resetProfileUpdatedFN: () => dispatch(resetProfileUpdated()),
        resetErrorMessageFN: () => dispatch(resetErrorMessage()),
        addProfileImageFN: (file) => dispatch(addProfileImage(file)),
        changePasswordFN: (passwords) => dispatch(changePassword(passwords)),
        sendPasswordResetFN: (email) => dispatch(sendPasswordReset(email)),
        getSettingsFN: () => dispatch(getSettings()),
        logOutFN: () => dispatch(logOut()),
    };
};

export default compose(connect(mapStateToProps, mapDispatchToProps))(Profile);